<div class="wait-container">
    <div class="wait-message">
      <h1>Preparando su entorno, por favor espere...</h1>
      <!-- <div class="spinner"></div> -->
    </div>
  </div>
  